import { Type } from 'class-transformer';
import * as moment from 'moment-timezone';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { ARMiscInvoiceTypeResultDto } from './ar-misc-invoice-type-result-dto';

export class ARMiscInvoiceEditorResultDto {
    @Type(() => ARMiscInvoiceTypeResultDto)
    invoiceTypes: ARMiscInvoiceTypeResultDto[];
    @Type(() => KeyValueResultDto)
    subLedgers: KeyValueResultDto[];
    entityUsesSubCategory: boolean;
    @Type(() => Date)
    closedBookPeriod: Date;
    defaultBankName: string;

    get minPostDate(): Date {
        return !!this.closedBookPeriod ? moment(this.closedBookPeriod).add(1, 'day').toDate() : null;
    }
}
